import React, { useState, useEffect } from 'react';
import { api } from '../api';

export default function LibraryPicker({ onClose, onAdd }) {
  const [items, setItems] = useState([]);
  const [sel, setSel] = useState({});
  const [q, setQ] = useState('');
  useEffect(() => { (async () => {
    const all = [];
    for (const s of ['core', 'customer', 'personal']) { const r = await api.listProducts({ scope: s }); all.push(...r.items); }
    setItems(all);
  })(); }, []);
  const filtered = items.filter(p => !q || ((p.name || '') + (p.code || '')).toLowerCase().includes(q.toLowerCase()));
  const chosen = items.filter(p => sel[p.id]);
  return (
    <div className="modal-overlay" data-testid="library-picker" onMouseDown={onClose}>
      <div className="modal" onMouseDown={e => e.stopPropagation()}>
        <h3>Add datasheets from the library</h3>
        <input className="input" placeholder="Search…" value={q} onChange={e => setQ(e.target.value)} />
        <div className="picker-list">
          {filtered.length === 0 ? <div className="empty-note">No datasheets in the library yet.</div> :
            filtered.map(p => (
              <label key={p.id} className={'picker-row' + (sel[p.id] ? ' on' : '')} data-testid={'picker-' + p.id}>
                <input type="checkbox" checked={!!sel[p.id]} onChange={e => setSel(s => ({ ...s, [p.id]: e.target.checked }))} />
                <span>{p.name || '(Untitled)'}{p.code ? <em> · {p.code}</em> : null}</span>
              </label>
            ))}
        </div>
        <div className="modal-actions">
          <button className="btn" onClick={onClose}>Cancel</button>
          <button className="btn btn-primary" data-testid="picker-add" disabled={chosen.length === 0} onClick={() => onAdd(chosen)}>Add {chosen.length || ''}</button>
        </div>
      </div>
    </div>
  );
}
